import UserProfile from '@/models/UserProfile'
import ChildBook from '../models/ChildBook'
import { callApi } from '@/_core/api/apiWrapper'

export const getProfile = async () => {
  const response = await callApi({
    method: 'get',
    url: 'profile/'
  })
  if (response.data) response.data = new UserProfile(response.data)
  return response
}

export const getProgress = async childId => {
  const response = await callApi({
    method: 'get',
    url: `child-progress/${childId}/`
  })
  if (response.data && response.data.results) {
    response.data.results = response.data.results.map(data => new ChildBook(data))
  }
  return response
}

export const denyTutorial = async () => {
  const response = await callApi({
    method: 'post',
    url: 'profile/deny-tutorial/'
  })
  return response
}

export const demo = async () => {
  const response = await callApi({
    method: 'get',
    url: 'profile/subscription/'
  })
  // const response = {
  //   data: {
  //     type: 'none',
  //     expires: '2022-01-28T10:13:47Z',
  //     purchase_link: 'https://dev.media.prosv.ru/payment/pay/00-0023-01/',
  //     purchase_text: 'Оформить подписку за 689р.',
  //     trial_period: 8,
  //     cost: 689.0,
  //     expiration_days: 0
  //   }
  // }
  return response
}

export const subscriptions = async () => {
  const response = await callApi({
    method: 'get',
    url: 'subscription/'
  })
  // const response = {
  //   data: [
  //     {
  //       nomenklatura: '00-0021-01', // rus
  //       expires: '2022-02-26T00:03:21Z',
  //       type: 'book',
  //       bought: true
  //     },
  //     {
  //       nomenklatura: '00-0020-01', // math
  //       expires: '2022-01-29T08:52:01.076944Z',
  //       type: 'book',
  //       bought: false
  //     },
  //     {
  //       nomenklatura: '00-0022-01', // vpr
  //       expires: '2023-01-29T08:52:01.103776Z',
  //       type: 'vpr',
  //       bought: true
  //     }
  //   ]
  // }
  return response
}
